<template>
	<v-footer
		id="dashboard-core-footer"
	>
		<v-container>
			<v-row
				align="center"
				no-gutters
			>
				<v-spacer class="hidden-sm-and-down" />

				<v-col
					cols="12"
					md="auto"
				>
					<div class="body-1 font-weight-light pt-6 pt-md-0 text-center">
						&copy; 2020, made
						by <a href="https://www.closeapp.co.il">CloseApp Team</a> for a better web.
					</div>
				</v-col>
			</v-row>
		</v-container>
	</v-footer>
</template>

<script>
	export default {
		name: "dashboard-core-footer",

		data: () => ({}),
	};
</script>

<style lang="sass">
  #dashboard-core-footer
    a
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>
